import palette from '../../theme/palette'

export const inputLabelContainerStyle = {
	mb: '8px',
}

export const inputLabelStyle = {
	fontSize: '14px',
	lineHeight: '16px',
	color: palette.text.darkBlue,
	fontWeight: '500',
	'&.optional': {
		fontWeight: 'normal',
	},
}

export const labelTooltipContainerStyle = { display: 'flex', justifyContent: 'space-between' }
